<template>
  <div class="main">
    <div class="head" id="head">
      <img src="../assets/inm_logo.png" class="inmLogo" />
    </div>

    <div class="content" id="18会员日" v-if="activeIndex == 0">
      <img src="../assets/t1.jpg" class="contentBg" v-if="sence == 1" />
      <img src="../assets/t2.jpg" class="contentBg" v-if="sence == 2" />
      <img src="../assets/t3.jpg" class="contentBg" v-if="sence == 3" />
      <img src="../assets/xxbg.png" class="contentBg" v-if="sence == 4" />
      <div class="playerWarp">
        <div class="player">
          <div class="kbEnter">
            <img src="../assets/kb.png" class="kbEnterImg" mode="scaleToFill" />
          </div>
          <p class="musicName">{{ activeSongObj.title }}</p>
          <div class="playerMid" id="playerMid">
            <el-progress
              :width="248"
              color="#FFD014"
              class="progressBtn"
              type="circle"
              :percentage="percentage"
              status="warning"
            ></el-progress>
            <img
              src="../assets/t1_s.jpg"
              v-if="sence == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/t2_s.jpg"
              v-if="sence == 2"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/t3_s.jpg"
              v-if="sence == 3"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/xx.png"
              v-if="sence == 4 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/sw.png"
              v-if="sence == 4 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <img
              src="../assets/18_1.png"
              v-if="sence == 2 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/18_2.png"
              v-if="sence == 2 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <img
              src="../assets/zw_1.jpg"
              v-if="sence == 3 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/zw_2.jpg"
              v-if="sence == 3 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <div
              :class="[
                'boxShadowed1',
                typeActive == 1 ? 'playerxx' : 'playersw',
              ]"
            ></div>
          </div>
          <div class="controlBox">
            <p class="playCont">
              正在播歌：<span class="boldtxtss">{{ inlineNum }}</span
              >家店铺
            </p>
            <div class="progress">
              <div
                class="progressBar"
                title="切换进度"
                @click.stop="progessClick"
                ref="totProgress"
              >
                <div
                  class="nowDue"
                  :style="{ width: progressLen + 'px' }"
                ></div>
                <div
                  class="progressEnd"
                  :style="{ left: progressLen + 'px' }"
                  @touchstart="drag"
                ></div>
              </div>
              <div class="nowTime">{{ activeMinute }}:{{ activeSeconds }}</div>
              <div class="totalTime">{{ musicMinute }}:{{ musicSeconds }}</div>
            </div>
            <div class="btnLists">
              <div class="preBtn" title="上一首" @click="preSong"></div>
              <div class="playBtnBg">
                <div class="playBtn" @click="handlePlayEvent">
                  <img
                    src="../assets/play.png"
                    title="播放"
                    v-if="model == 'play'"
                    class="playBtnen"
                  />
                  <img
                    src="../assets/stop.png"
                    title="暂停"
                    v-if="model == 'pause'"
                    class="stopBtnen"
                  />
                </div>
              </div>
              <div class="nextBtn" title="下一首" @click="handleNextSong"></div>
            </div>
          </div>
          <div class="sounds">
            <div class="soundBtn">
              <img
                src="~@/assets/sound.png"
                class="soundIcon"
                v-if="soundModel == 'normal'"
                title="静音"
                @click="soundModelChange(true)"
              />
              <img
                src="~@/assets/noSound.png"
                class="soundIcon hh"
                @click="soundModelChange(false)"
                v-if="soundModel == 'ban'"
              />
              <div class="soundProgress" @click.stop="soundProgessClick">
                <div class="soundTotProgress" ref="soundTotProgress"></div>
                <div
                  class="nowProgress"
                  :style="{ width: soundProgressLen + 'px' }"
                  title="调节音量"
                ></div>
                <div
                  class="soundEndProgress"
                  ref="soundEndProgress"
                  :style="{ left: soundProgressLen - playWidth + 'px' }"
                  @mousedown="soundDraged"
                ></div>
              </div>
              <img
                src="~@/assets/soundmax.png"
                class="soundIcon ml-7"
                @click="toggleMaxSound"
                title="最大音量"
              />
            </div>
          </div>
          <div class="otherInfo">
            <div class="otherInfoTit">
              <div class="otherInfoLeft">
                制作人：<span class="boldtxt">{{
                  activeSongObj.producer
                }}</span>
              </div>
              <div class="otherInfoRight">
                录音师：<span class="boldtxt">{{
                  activeSongObj.recordEngineer
                }}</span>
              </div>
            </div>
            <div class="desc">
              <p class="descTit">作者的话</p>
              <p class="descTxt">{{ activeSongObj.remark }}</p>
            </div>
          </div>

          <div class="KBwarp">
            <div class="soundWarp">
              <el-form :model="ruleForm" label-width="80px">
                <el-form-item label="口播音量" prop="pass">
                  <el-slider
                    @change="sliderChange"
                    v-model="ruleForm.sound"
                    :max="10"
                  ></el-slider>
                </el-form-item>
              </el-form>
            </div>
            <div class="KBcontent">
              <el-checkbox-group
                @change="checkChange(data)"
                v-model="checkList"
              >
                <div
                  class="KBitem"
                  v-for="item in tryListenList"
                  :key="item.id"
                >
                  <div class="Kbname">
                    <el-checkbox size="large" :value="item.id" :label="item.id">
                      <span class="Kbname">{{ item.name }}</span>
                    </el-checkbox>
                  </div>
                  <span class="soundImg">
                    <img
                      title="试听"
                      class="tryListenIcon"
                      src="~@/assets/tryListen.png"
                      @click="tryListen(item.fileUrl)"
                    />
                  </span>
                  <span class="moreInfo">
                    <el-popover
                      :width="350"
                      popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
                    >
                      <template #reference>
                        <img
                          title="详情"
                          class="tryListenIcon"
                          src="~@/assets/mainInfo.png"
                        />
                      </template>
                      <template #default>
                        <div
                          class="demo-rich-conent"
                          style="display: flex; gap: 16px; flex-direction: column"
                        >
                          <div>
                            <p
                              class="demo-rich-content__name"
                              style="margin-bottom: 10px; font-weight: 500;font-size:16px"
                            >
                              {{ item.name }}
                            </p>
                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">生效日期：</span>
                              {{ item.startDate }}到
                              {{ item.endDate }}
                            </p>
                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">生效日期：</span>
                              {{ formatTime(item.intervalTime) }}
                            </p>

                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">生效时间段：</span
                              ><el-tag
                                size="mini"
                                class="tagItem"
                                v-for="item in item.timesList"
                              >
                                <span
                                  v-if="
                                    item.startTime == '00:01' &&
                                      item.endTime == '23:59'
                                  "
                                >
                                  全天
                                </span>
                                <span v-else>
                                  {{ simplifyHour(item.startTime) }} 到
                                  {{ simplifyHour(item.endTime) }}
                                </span>
                              </el-tag>
                            </p>
                          </div>

                          <p
                            class="demo-rich-content__desc"
                            v-if="item.remark"
                            style="margin: 0"
                          >
                            {{ item.remark }}
                          </p>
                        </div>
                      </template>
                    </el-popover>
                  </span>
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content" id="其他" v-if="activeIndex == 1">
      <img
        src="../assets/xxbg.png"
        v-if="sence == 4 && typeActive == 1"
        class="contentBg"
      />
      <img
        src="../assets/swbg.png"
        v-if="sence == 4 && typeActive == 0"
        class="contentBg"
      />
      <img src="../assets/t2.jpg" class="contentBg" v-if="sence == 2" />
      <img src="../assets/t3.jpg" class="contentBg" v-if="sence == 3" />
      <div class="playerWarp">
        <div class="player">
          <div class="kbEnter">
            <img src="../assets/kb.png" class="kbEnterImg" mode="scaleToFill" />
          </div>
          <p class="musicName">{{ activeSongObj.title }}</p>
          <div class="playerMid" id="playerMid">
            <el-progress
              :width="248"
              color="#FFD014"
              class="progressBtn"
              type="circle"
              :percentage="percentage"
              status="warning"
            ></el-progress>
            <img
              src="../assets/xx.png"
              v-if="sence == 4 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/sw.png"
              v-if="sence == 4 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <img
              src="../assets/18_1.png"
              v-if="sence == 2 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/18_2.png"
              v-if="sence == 2 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <img
              src="../assets/zw_1.jpg"
              v-if="sence == 3 && typeActive == 1"
              :class="[
                'playerMidPic',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />
            <img
              src="../assets/zw_2.jpg"
              v-if="sence == 3 && typeActive == 0"
              :class="[
                'boxShadow',
                'xuanzhuan',
                model != 'play' ? 'suspended' : '',
              ]"
            />

            <div
              :class="[
                'boxShadowed',
                typeActive == 1 ? 'playerxx' : 'playersw',
              ]"
            ></div>
          </div>
          <div class="controlBox">
            <p class="playCont">
              正在播歌：<span class="boldtxtss">{{ inlineNum }}</span
              >家店铺
            </p>
            <div class="progress">
              <div
                class="progressBar"
                title="切换进度"
                @click.stop="progessClick"
                ref="totProgress"
              >
                <div
                  class="nowDue"
                  :style="{ width: progressLen + 'px' }"
                ></div>
                <div
                  class="progressEnd"
                  :style="{ left: progressLen + 'px' }"
                  @touchstart="drag"
                ></div>
              </div>
              <div class="nowTime">{{ activeMinute }}:{{ activeSeconds }}</div>
              <div class="totalTime">{{ musicMinute }}:{{ musicSeconds }}</div>
            </div>
            <div class="btnLists">
              <div class="preBtn" title="上一首" @click="preSong"></div>
              <div class="playBtnBg">
                <div class="playBtn" @click="handlePlayEvent">
                  <img
                    src="../assets/play.png"
                    title="播放"
                    v-if="model == 'play'"
                    class="playBtnen"
                  />
                  <img
                    src="../assets/stop.png"
                    title="暂停"
                    v-if="model == 'pause'"
                    class="stopBtnen"
                  />
                </div>
              </div>
              <div class="nextBtn" title="下一首" @click="handleNextSong"></div>
            </div>
          </div>
          <div class="sounds">
            <div class="soundBtn">
              <img
                src="~@/assets/sound.png"
                class="soundIcon"
                v-if="soundModel == 'normal'"
                title="静音"
                @click="soundModelChange(true)"
              />
              <img
                src="~@/assets/noSound.png"
                class="soundIcon hh"
                @click="soundModelChange(false)"
                v-if="soundModel == 'ban'"
              />
              <div class="soundProgress" @click.stop="soundProgessClick">
                <div class="soundTotProgress" ref="soundTotProgress"></div>
                <div
                  class="nowProgress"
                  :style="{ width: soundProgressLen + 'px' }"
                  title="调节音量"
                ></div>
                <div
                  class="soundEndProgress"
                  ref="soundEndProgress"
                  :style="{ left: soundProgressLen - playWidth + 'px' }"
                  @mousedown="soundDraged"
                ></div>
              </div>
              <img
                src="~@/assets/soundmax.png"
                class="soundIcon ml-7"
                @click="toggleMaxSound"
                title="最大音量"
              />
            </div>
          </div>
          <div class="otherInfo">
            <div class="otherInfoTit">
              <div class="otherInfoLeft">
                制作人：<span class="boldtxt">{{
                  activeSongObj.producer
                }}</span>
              </div>
              <div class="otherInfoRight">
                录音师：<span class="boldtxt">{{
                  activeSongObj.recordEngineer
                }}</span>
              </div>
            </div>
            <div class="desc">
              <p class="descTit">作者的话</p>
              <p class="descTxt">{{ activeSongObj.remark }}</p>
            </div>
          </div>

          <div class="toggleTab">
            <div class="tabs percentage10">
              <span
                @click="toggleSongTab(0)"
                :class="[typeActive == '0' ? 'active' : '']"
                >商务</span
              >
            </div>
            <div class="tabs">
              <span
                @click="toggleSongTab(1)"
                :class="[typeActive == '1' ? 'active' : '']"
                >社区</span
              >
            </div>
          </div>
          <div class="KBwarp">
            <div class="soundWarp">
              <el-form :model="ruleForm" label-width="80px">
                <el-form-item label="口播音量" prop="pass">
                  <el-slider
                    @change="sliderChange"
                    v-model="ruleForm.sound"
                    :max="10"
                  ></el-slider>
                </el-form-item>
              </el-form>
            </div>
            <div class="KBcontent">
              <el-checkbox-group
                @change="checkChange(data)"
                v-model="checkList"
              >
                <div
                  class="KBitem"
                  v-for="item in tryListenList"
                  :key="item.id"
                >
                  <div class="Kbname">
                    <el-checkbox size="large" :value="item.id" :label="item.id">
                      <span class="Kbname">{{ item.name }}</span>
                    </el-checkbox>
                  </div>
                  <span class="soundImg">
                    <img
                      title="试听"
                      class="tryListenIcon"
                      src="~@/assets/tryListen.png"
                      @click="tryListen(item.fileUrl)"
                    />
                  </span>
                  <span class="moreInfo">
                    <el-popover
                      :width="350"
                      popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
                    >
                      <template #reference>
                        <img
                          title="详情"
                          class="tryListenIcon"
                          src="~@/assets/mainInfo.png"
                        />
                      </template>
                      <template #default>
                        <div
                          class="demo-rich-conent"
                          style="display: flex; gap: 16px; flex-direction: column"
                        >
                          <div>
                            <p
                              class="demo-rich-content__name"
                              style="margin-bottom: 10px; font-weight: 500;font-size:16px"
                            >
                              {{ item.name }}
                            </p>
                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">生效日期：</span>
                              {{ item.startDate }}到
                              {{ item.endDate }}
                            </p>
                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">循环时长：</span>
                              {{ formatTime(item.intervalTime) }}
                            </p>

                            <p
                              class="demo-rich-content__mention"
                              style="margin-bottom: 5px; font-size: 14px; color: var(--el-color-info)"
                            >
                              <span class="contentTitle">生效时间段：</span
                              ><el-tag
                                size="mini"
                                class="tagItem"
                                v-for="item in item.timesList"
                              >
                                <span
                                  v-if="
                                    item.startTime == '00:01' &&
                                      item.endTime == '23:59'
                                  "
                                >
                                  全天
                                </span>
                                <span v-else>
                                  {{ simplifyHour(item.startTime) }} 到
                                  {{ simplifyHour(item.endTime) }}
                                </span>
                              </el-tag>
                            </p>
                          </div>

                          <p
                            class="demo-rich-content__desc"
                            v-if="item.remark"
                            style="margin: 0"
                          >
                            {{ item.remark }}
                          </p>
                        </div>
                      </template>
                    </el-popover>
                  </span>
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom" v-if="ready">
      <div class="introduce">
        <p class="introTit">关于我们</p>
        <p class="introtxts">
          杭州万像循声文化传媒有限公司（SoundPic
          HangZhou）成立于2016年，公司位于浙江省杭州市滨江区江陵路567号，是一家以电影电视节目制作与发行为支柱产业的传媒公司，是浙江传媒学院等艺术类院校培养广播影视及其他传媒人才的实训基地。公司拥有标准电影电视7.1声道混合录
          音棚、电影电视5.1声道预混棚、多功能综合录音棚、音乐创作编曲室、音频编辑室等专业声音创作、制作场地。配套一线专业声音制作设备与人才满足院线电影、电视剧、电视节目、广
          告、动画片、VR音频节目制作等节目作品的音乐创作与声音制作。
          公司成立至今以专业的服务与专心的态度使公司与中国中央电视台、浙江广播电视集团、江苏省广播电视总台、重庆广播电视集团、等多家省市广播电视单位及多个影视公司保持业务关系。先后参与创作上百部影视佳作，获得众多奖项。其中包括：第26届米兰国际体育电影电视节最高奖——荣誉花环奖、第15届上海电视节“白玉兰”奖历史文献类纪录片银奖、中国广播影视大奖--广播电视节目奖特别奖、第五届中国纪录片国际选片会“十大纪录片”、
          “纪录中国”2009年度优秀节目一等奖、第28届米兰国际体育电影电视节最高奖——荣誉花环奖、2010年度广播电视协会优秀体育节目一等奖、第十一届四川电视节“金熊猫”奖国际纪录片评选评委特别奖、第29届米兰国际体育电影电视节提名奖、中国广播影视大奖·广播电视节目奖（第23届“星光奖”）电视纪录片大奖、第六届北京国际微电影节提名中国学院声音最高奖项——中国电影电视家学会“声音学院奖”
          、上海之声国际音乐节第三届数字音频大赛大赛编曲组提名、四届“中国梦微电影大赛”剧情单元奖、西宁FIRST青年影展剧情长片竞赛单元提名等；并得到众多导演、制片人、电影公司以及发行商的赞誉。
          万像循声是一个全球化的电影制作群体。在旧金山和杭州、重庆、南京等地设立的先进设备通过高速网络连接，我们为影视行业提供着同一水准的高标准影视声音制作服务。您可以选择任何一处来完成全部的声音制作，也可以选择利用这三处共同来完成项目，以保证项目实现最好的效果。
        </p>
      </div>
      <div class="detailed">
        <p class="introTit">联系我们</p>
        <p class="touchUs">
          <img src="../assets/phone.png" />
          0571-86791326
        </p>
        <p class="touchUs">
          <img src="../assets/iPhone.png" />
          157 5716 3177
        </p>
        <p class="touchUs">
          <img src="../assets/addr.png" />
          浙江杭州滨江区江陵路567号
        </p>
        <p class="touchUs">
          <img src="../assets/email.png" />
          wxxs@soundpic.cn
        </p>
        <p class="touchUs iconHand">
          <img src="../assets/webURL.png" />
          <a href="http://www.soundpic.cn" class="urlColor" target="_blank"
            >www.soundpic.cn</a
          >
        </p>
        <div class="midWareright" id="midWareright"></div>
      </div>
    </div>
    <audio id="audioBox" :src="activeUrl"></audio>
    <audio id="kbAudioBox" :src="kbUrl"></audio>

    <div id="audio-player-container"></div>
    <el-drawer
      title="口播设置(勾选您需要的口播，勾选后立即生效)"
      size="60%"
      :visible.sync="drawer"
    >
      <div style="width: 26%;margin-left:2%;">
        <el-form :model="ruleForm" label-width="80px">
          <el-form-item label="口播音量" prop="pass">
            <el-slider
              @change="sliderChange"
              v-model="ruleForm.sound"
              :max="10"
            ></el-slider>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        ref="multipleTable"
        :data="tryListenList"
        tooltip-effect="dark"
        stripe
        style="width: 96%;margin-left:2%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"> </el-table-column>
        <el-table-column prop="name" label="名称" width="160">
          <template slot-scope="scope">
            <div class="tryListenItem">
              {{ scope.row.name }}
              <img
                title="试听"
                class="tryListenIcon"
                src="~@/assets/tryListen.png"
                @click="tryListen(scope.row.fileUrl)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="循环时长" label="循环时长" width="80">
          <template slot-scope="scope">
            {{ formatTime(scope.row.intervalTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="生效日期"
          width="230"
          label="生效日期"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.startDate }}到
            {{ scope.row.endDate }}
          </template>
        </el-table-column>
        <el-table-column prop="生效时间段" label="生效时间段" width="200">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              class="tagItem"
              v-for="item in scope.row.timesList"
            >
              <span v-if="item.startTime == '00:01' && item.endTime == '23:59'">
                全天
              </span>
              <span v-else>
                {{ simplifyHour(item.startTime) }} 到
                {{ simplifyHour(item.endTime) }}
              </span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import {
  getMusicByAlbumId,
  changeMusicType,
  getUserCount,
  todayList,
  getCurTime,
  wxKbList,
  batchSave,
  getNextPlayInfo,
} from "../request/api.js";
export default {
  data() {
    return {
      drawer: false,
      sence: 0, //1=早餐，2=18会员日，3=周五
      typeActive:
        localStorage.getItem("typeIndex") == 0 ||
        localStorage.getItem("typeIndex") == 1
          ? localStorage.getItem("typeIndex")
          : 0,
      musicMinute: "00",
      musicSeconds: "00",
      activeMinute: "00",
      activeSeconds: "00",
      progressLen: 0,
      oldSound: 0.5,
      activeUrl: "",
      kbUrl: "",
      timeInter: null,
      myVid: null,
      timeout: null,
      kbVid: null,
      ctx: null,
      ALLTIME: 0,
      domWidth: 0,
      tryListenList: [], //口播列表
      model: "pause",
      activeSongIndex: 0,
      percentage: 0,
      songList: [],
      senceList: [],
      activeSongObj: {},
      ruleForm: {
        sound: localStorage.getItem("kbVoice")
          ? Number(localStorage.getItem("kbVoice"))
          : 10,
      },
      inlineNum: 0,
      swiperHeight: "0px",
      cycleTask: null,
      soundModel: "normal",
      soundProgressLen: 0,
      playWidth: 0,
      myVidVolume: 1,
      checkList: [],
      SoundprogressWidth: null,
      initialIndex: 0,
      ready: false,
      time: 0,
      myInter: null,
      dataAll: [],
      currentAudio: null,
      selectIndexArr: [],
      drawerLoading: false,
      activeSenceId: null,
      koTimeout: null,
      activeIndex: 0,
      nowTime: new Date(
        this.$route.query.date + " " + this.$route.query.time
      ).getTime(),
    };
  },
  computed: {
    music() {
      return this.activeUrl;
    },
  },

  mounted() {
    let hight = document.getElementById("head").clientHeight;
    this.swiperHeight = parseInt(hight * 11.363) + "px";
    setTimeout(() => {
      this.initMap();
    }, 2000);

    this.timeDown();
  },
  destroyed() {
    clearInterval(this.timeInter);
    clearInterval(this.myInter);
  },
  created() {
    this.getSence();
    this.getKbList();
    setTimeout(() => {
      //3秒再去加载口播播放器
      this.getKbPlayer();
    }, 3000);
  },
  watch: {
    music(val) {
      let me = this;
      this.activeSongObj = this.songList[this.activeSongIndex];
      this.playWidth = parseInt(this.$refs.soundEndProgress.offsetWidth / 2);
      if (!this.domWidth) {
        this.domWidth = this.$refs.totProgress.offsetWidth;
        this.SoundprogressWidth = this.$refs.soundTotProgress.offsetWidth;
        this.myVid = document.getElementById("audioBox");
        this.kbVid = document.getElementById("kbAudioBox");
        this.soundProgressLen = this.myVid.volume * this.SoundprogressWidth;
        this.myVid.addEventListener(
          "ended",
          () => {
            me.handleMusicEnded(); //判断歌放完了
          },
          false
        );
      }
      this.playMusic();
    },
  },
  methods: {
    simplifyHour(time) {
      if (!time) {
        return "";
      }
      if (time == "00:01") {
        return "00:00";
      }
      if (time == "23:59") {
        return "24:00";
      }
      return time;
    },
    sliderChange(data) {
      this.ruleForm.sound = data;
      localStorage.setItem("kbVoice", data);
      this.kbVid.volume = data / 10;
      if (!this.kbVid.paused) {
        this.myVid.volume = this.calculateOutput(); //降低主频音乐声音
      }
    },
    async getKbPlayer() {
      //获取口播待播放列表
      const res = await getNextPlayInfo();
      if (!res.data) {
        //如果没有获取到可以播放的口播列表，隔两分钟再去取一次
        this.koTimeout = setTimeout(() => {
          this.getKbPlayer();
        }, 120000);
      } else {
        //获取到了要播放的口播音频列表

        this.kbUrl = res.data.fileUrl;
        if (this.myVidVolume == 0) {
          this.kbVid.volume = 0;
        } else {
          this.kbVid.volume = this.ruleForm.sound / 10; //获取配置的口播声音
        }

        this.koTimeout = setTimeout(() => {
          //倒计时
          this.myVid.volume = this.calculateOutput(); //降低主频音乐声音
          this.kbVid
            .play()
            .then(() => {})
            .catch(this.kbPlayError); //播放失败，两分钟倒计时再去取
          this.kbVid.addEventListener("ended", this.kbPlay); //监听结束
        }, res.data.offsetTime * 1000);
      }
    },
    graduallyChangeVolume(audioElement, targetVolume, duration) {
      //声音缓入
      const interval = 100; // 每 100 毫秒调整一次音量
      const step = (targetVolume - audioElement.volume) / (duration / interval); // 每次调整的音量步长
      const volumeInterval = setInterval(() => {
        if (
          (step > 0 && audioElement.volume < targetVolume) ||
          (step < 0 && audioElement.volume > targetVolume)
        ) {
          audioElement.volume = Math.min(
            Math.max(audioElement.volume + step, 0),
            targetVolume
          ); // 调整音量并确保在 0 和目标音量之间
        } else {
          clearInterval(volumeInterval); // 达到目标音量后清除定时器
        }
      }, interval);
    },
    calculateOutput() {
      if (this.myVidVolume == 0) {
        return 0;
      }
      let sound = (this.myVidVolume * 1) / (this.ruleForm.sound + 1);
      return sound > 0.2 ? sound : 0.2;
    },
    kbPlayError(error) {
      //播放失败

      this.myVid.volume = this.myVidVolume;
      setTimeout(() => {
        this.getKbPlayer();
      }, 120000);
      this.kbVid.removeEventListener("ended", this.kbPlay);
    },
    kbPlay() {
      //播放成功
      //口播播放结束

      this.graduallyChangeVolume(this.myVid, this.myVidVolume, 2000);

      this.kbVid.removeEventListener("ended", this.kbPlay);
      this.getKbPlayer();
    },
    async getKbList() {
      const res = await wxKbList({
        enabeld: 1,
        pageSize: 100,
      });
      this.tryListenList = res.rows;
      let selectArr = [];
      res.rows.map((child, index) => {
        if (child.selected) {
          selectArr.push(child.id);
        }
      });
      this.checkList = selectArr;

      this.selectIndexArr = selectArr;
    },
    handleSelectionChange(data) {
      if (!this.drawerLoading) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.sendSelectionChange(data);
        }, 1000);
      }
    },
    checkChange(data) {
      this.timeout = setTimeout(() => {
        this.sendSelectionChange(this.checkList);
      }, 1000);
    },
    async sendSelectionChange(arr) {
      batchSave(arr).then((res) => {
        if (arr.length) {
          // this.toast("保存成功,稍后自动播放");
        } else {
          this.toast("保存成功");
        }
        clearTimeout(this.koTimeout);
        this.getKbPlayer();
      });
    },
    async getSence() {
      const res = await todayList({
        day: this.$route.query.date,
      });
      this.senceList = res.data;
      this.getTime();
    },
    async enterKb() {
      this.drawer = true;
      this.drawerLoading = true;
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
        this.selectIndexArr.map((child) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.tryListenList[child]
          );
        });
        setTimeout(() => {
          this.drawerLoading = false;
        }, 100);
      });
    },
    async getTime() {
      const res = await getCurTime();
      if (this.$route.query.time && this.$route.query.date) {
        this.rangeTime(this.nowTime);
      } else {
        this.rangeTime(res.data);
      }

      this.myInter = setInterval(async () => {
        let resf = "";
        if (this.$route.query.time && this.$route.query.date) {
          this.nowTime = this.nowTime + 60000;
          resf = {
            data: this.nowTime,
          };
        } else {
          resf = await getCurTime();
        }

        this.rangeTime(resf.data);
      }, 60 * 1000);
    },
    onSongPlay(res, sence, id) {
      this.ready = true;
      this.activeIndex = 0;
      this.$nextTick(async () => {
        this.sence = sence.module;
        this.songList = res.data;
        this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
        this.activeSongObj = this.songList[this.activeSongIndex];
        this.getCount(id);
      });
    },
    async rangeTime(time) {
      let sence = "";
      this.senceList.map((child) => {
        if (time >= child.startTime && time <= child.endTime) {
          sence = child;
        }
      });
      debugger;
      if (sence) {
        if (sence.startTime != this.activeSenceId) {
          //那就是场景切换了
          this.activeSenceId = sence.startTime;
          this.activeSongIndex = 0; //歌曲从头开始播放
          //2.17改造
          debugger;
          if (sence.albumList.length == 2) {
            //普通模式

            //2.17   遍历专辑ID
            const reg = await getMusicByAlbumId({
              albumId: sence.albumList[0].id,
            });
            const ref = await getMusicByAlbumId({
              albumId: sence.albumList[1].id,
            });
            this.dataAll = [reg, ref];
            debugger;
            if (reg.data.length && ref.data.length) {
              //如果都有说明要进入模式1，双专辑模式
              this.activeIndex = 1;
              this.sence = sence.module;
              this.ready = true; //准备好了
              this.$nextTick(() => {
                this.getMusicList();
              });
            } else {
              //单专辑模式
              let index = 0;
              if (reg.data.length) {
                index = 0;
                this.onSongPlay(reg, sence, sence.albumList[index].id);
              } else if (ref.data.length) {
                index = 1;
                this.onSongPlay(ref, sence, sence.albumList[index].id);
              }
            }
            //this.activeIndex = 1; //模式1是有tab切换，2无
          } else {
            this.ready = true;
            await changeMusicType({
              musicType: sence.albumList[0].id,
            });
            this.activeIndex = 0;
            this.$nextTick(async () => {
              const res = await getMusicByAlbumId({
                albumId: sence.albumList[0].id,
                day: this.$route.query.date,
              });

              if (sence.albumList[0].albumName == "早餐歌单") {
                this.sence = 1;
              }
              if (sence.albumList[0].albumName == "会员日歌单") {
                this.sence = 2;
              }
              if (sence.albumList[0].albumName == "周五歌单") {
                this.sence = 3;
              }

              this.songList = res.data;
              this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
              this.activeSongObj = this.songList[this.activeSongIndex];
              this.getCount(sence.albumList[0].id);
            });
          }
        }
      } else {
        //没有就算跨天了
        if (this.$route.query.date) {
          this.$route.query.date = this.NextDay(this.$route.query.date);
        }
        this.getSence();
      }
    },
    NextDay(day) {
      // var nextDate = new Date(curDate.getTime() + 24*60*60*1000);
      var curDate = new Date(day);
      var nextDate = new Date(curDate.getTime() + 24 * 60 * 60 * 1000);

      var strDate = nextDate.getFullYear() + "-";
      strDate += nextDate.getMonth() + 1 + "-";
      strDate += nextDate.getDate();
      return strDate;
    },
    async getCount(id) {
      const res = await changeMusicType({
        musicType: id,
      });
      const ref = await getUserCount({
        musicType: id,
      });
      if (ref.code == 0) {
        this.inlineNum = ref.data;
      }
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      if (remainingSeconds != 0) {
        return `${minutes}分钟${remainingSeconds}秒`;
      } else {
        return `${minutes}分钟`;
      }
    },
    tonext() {},
    toggleMaxSound() {
      this.myVid.volume = 1;
      this.soundProgressLen = 1 * this.SoundprogressWidth;
      this.myVidVolume = 1;
    },
    soundModelChange(isban) {
      if (isban) {
        this.oldSound = this.myVidVolume;
        this.soundModel = "ban";
        this.myVid.volume = 0;
        this.soundProgressLen = 0;
        this.kbVid.volume = 0;
        this.myVidVolume = 0;
      } else {
        this.myVid.volume = this.oldSound;
        this.soundProgressLen = this.myVid.volume * this.SoundprogressWidth;
        this.soundModel = "normal";
        this.kbVid.volume = this.ruleForm.sound / 10;
        this.myVidVolume = this.oldSound;
      }
    },
    soundDraged(e) {
      let me = this;
      var clickX = e.x;
      var result = me.soundProgressLen;
      document.onmousemove = function(target) {
        target.preventDefault();
        var distX = target.clientX - clickX;

        if (result + distX <= 0) {
          me.soundProgressLen = 0;
        } else if (result + distX > me.SoundprogressWidth) {
          me.soundProgressLen = me.SoundprogressWidth;
        } else {
          me.soundProgressLen += distX;
          result += distX;
        }
        clickX = target.clientX;
        let sound = (me.soundProgressLen / me.SoundprogressWidth).toFixed(1);
        if (sound == "0.0") {
          me.soundModel = "ban";
        } else {
          me.soundModel = "normal";
        }
        if (sound >= 0 && sound <= 1) {
          me.myVid.volume = sound;
        } else if (sound < 0) {
          me.myVid.volume = 0;
        } else if (sound > 1) {
          me.myVid.volume = 1;
        }
        if (sound <= 0) {
          this.kbVid.volume = 0;
        } else {
          this.kbVid.volume = this.ruleForm.sound / 10;
        }
      };
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    soundProgessClick(e) {
      let me = this;
      e.stopPropagation();
      var domToLeft = this.$refs.soundTotProgress.getBoundingClientRect().left;
      var clientX = e.clientX;
      var result = me.soundProgressLen;
      var distX = clientX - domToLeft - result;
      if (result + distX <= 0) {
        me.soundProgressLen = 0;
        me.soundModel = "ban";
      } else if (result + distX > me.soundProgressWidth) {
        me.soundProgressLen = me.soundProgressWidth;
        me.soundModel = "normal";
      } else {
        me.soundProgressLen += distX;
        var point = me.soundProgressLen / me.soundProgressWidth;
        result += distX;
        me.soundModel = "normal";
      }
      let sound = (me.soundProgressLen / me.SoundprogressWidth).toFixed(1);
      if (sound >= 0 && sound <= 1) {
        me.myVid.volume = sound;
        me.myVidVolume = sound;
      } else if (sound < 0) {
        me.myVid.volume = 0;
        me.myVidVolume = 0;
      } else if (sound > 1) {
        me.myVid.volume = 1;
        me.myVidVolume = 1;
      }
    },
    async getMusicList() {
      const res = this.dataAll[this.typeActive];
      debugger;
      await changeMusicType({
        musicType: this.typeActive,
      });
      this.songList = res.data;
      this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
      this.activeSongObj = this.songList[this.activeSongIndex];
      const ref = await getUserCount({
        musicType: this.typeActive,
      });
      if (ref.code == 0) {
        this.inlineNum = ref.data;
      }
    },
    initMap() {
      var map = new AMap.Map("midWareright", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 14, //初始化地图层级
        center: [120.217329, 30.185979], //初始化地图中心点
        mapStyle: "amap://styles/grey",
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(120.217329, 30.185979),
      });
      map.add(marker);
    },
    handleMusicEnded() {
      let me = this;
      if (this.songList.length == 1 || this.songList.length == 0) {
        //如果歌单只有一首歌了 或歌单无歌，则循环播放
        this.myVid.currentTime = 0;

        this.myVid.play();
        if (!me.timeInter) {
          me.timeInter = setInterval(() => {
            me.plays(me.myVid.currentTime);
          }, 100);
        }
      } else {
        //如果不是，则播放下一首

        this.nextSong();
        if (!me.timeInter) {
          me.timeInter = setInterval(() => {
            me.plays(me.myVid.currentTime);
          }, 100);
        }
      }
    },
    nextSong() {
      //多首歌的情况下 ，判断当前播放哪首歌 下一首

      let songIndex = this.activeSongIndex; //先获取当前这首歌在歌单列表中的位置
      if (songIndex == this.songList.length - 1) {
        //如果当前已经是最后一首
        this.activeSongIndex = 0;
        this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
      } else {
        this.activeSongIndex = songIndex + 1;
        this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
      }
    },
    handleNextSong() {
      let me = this;
      this.model = "play";
      if (!me.timeInter) {
        me.timeInter = setInterval(() => {
          me.plays(me.myVid.currentTime);
        }, 100);
      }
      if (this.songList.length == 1 || this.songList.length == 0) {
        //如果歌单只有一首歌了 或歌单无歌，则循环播放

        this.myVid.currentTime = 0;
        this.myVid.play();
      } else {
        //如果不是，则播放下一首
        this.nextSong();
        if (!me.timeInter) {
          me.timeInter = setInterval(() => {
            me.plays(me.myVid.currentTime);
          }, 100);
        }
      }
    },
    preSong() {
      let me = this;
      this.model = "play";
      if (!me.timeInter) {
        me.timeInter = setInterval(() => {
          me.plays(me.myVid.currentTime);
        }, 100);
      }
      if (this.songList.length == 1 || this.songList.length == 0) {
        //如果歌单只有一首歌了 或歌单无歌，则循环播放
        this.myVid.currentTime = 0;
        this.myVid.play();
      } else {
        //如果不是，则播放下一首
        this.prevSong();
        if (!me.timeInter) {
          me.timeInter = setInterval(() => {
            me.plays(me.myVid.currentTime);
          }, 100);
        }
      }
    },
    prevSong() {
      let songIndex = this.activeSongIndex; //先获取当前这首歌在歌单列表中的位置
      if (songIndex == 0) {
        //如果当前已经是第一首（去最后一首）
        this.activeSongIndex = this.songList.length - 1;
        this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
      } else {
        this.activeSongIndex = songIndex - 1;
        this.activeUrl = this.songList[this.activeSongIndex].musicUrl;
      }
    },
    handlePlayEvent() {
      let me = this;
      if (me.myVid.paused) {
        me.myVid.play(); //// 播放
        me.plays(me.myVid.currentTime);
        if (!me.timeInter) {
          me.timeInter = setInterval(() => {
            me.plays(me.myVid.currentTime);
          }, 100);
        }
        this.model = "play";
      } else {
        me.myVid.pause(); // 暂停
        clearInterval(me.timeInter);
        me.timeInter = null;
        this.model = "pause";
      }
    },
    playMusic() {
      let me = this;
      me.myVid.load();
      me.myVid.oncanplay = function() {
        me.ALLTIME = parseInt(me.myVid.duration);
        me.musicMinute =
          Number(me.ALLTIME / 60) < 10
            ? "0" + parseInt(Number(me.ALLTIME / 60))
            : parseInt(Number(me.ALLTIME / 60));
        me.musicSeconds =
          Number(me.ALLTIME % 60) < 10
            ? "0" + parseInt(Number(me.ALLTIME % 60))
            : parseInt(Number(me.ALLTIME % 60));
        me.myVid.play();
        me.myVid.addEventListener("playing", function() {
          me.model = "play";
        });

        this.inplay = true;
      };
      if (!me.timeInter) {
        me.timeInter = setInterval(() => {
          me.plays(me.myVid.currentTime);
        }, 500);
      }
    },
    plays(time) {
      if (this.ALLTIME) {
        let me = this;
        this.drawProcess(time);
        var point = time / me.ALLTIME;
        me.activeMinute =
          Number((me.ALLTIME * point) / 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) / 60))
            : parseInt(Number((me.ALLTIME * point) / 60));
        me.activeSeconds =
          Number((me.ALLTIME * point) % 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) % 60))
            : parseInt(Number((me.ALLTIME * point) % 60));
        me.domWidth = this.$refs.totProgress.getBoundingClientRect().width;
        me.progressLen = point * me.domWidth;
      }
    },
    tryListen(url) {
      this.playPreview(url);
    },
    async toggleSongTab(index) {
      if (index == 0 || index == 1) {
        this.typeActive = index;
        localStorage.setItem("typeIndex", index);
      }

      const res = await changeMusicType({
        musicType: index,
      });

      this.activeSongIndex = 0;
      this.activeUrl = "";
      this.toast("已为您成功切换歌单");
      this.getMusicList();
      this.timeDown();
    },
    async timeDown() {
      if (this.cycleTask) {
        clearTimeout(this.cycleTask);
      }
      this.cycleTask = setTimeout(async () => {
        const res = await changeMusicType({
          musicType: this.typeActive,
        });
        this.timeDown();
      }, 1000 * 60 * 30);
    },
    drag(e) {
      let me = this;
      this.clickX = e.target.x;
      clearInterval(me.timeInter);
      document.addEventListener("touchmove", me.touchMoveEvent);
      document.addEventListener("touchend", me.touchEndEvent);
    },
    touchEndEvent() {
      let me = this;
      document.removeEventListener("touchmove", me.touchMoveEvent);
      me.myVid.currentTime = (me.progressLen / me.domWidth) * me.ALLTIME;
      me.timeInter = setInterval(() => {
        me.plays(me.myVid.currentTime);
      }, 100);
      document.removeEventListener("touchend", me.touchEndEvent);
      me.playStatus = 1;
    },
    touchMoveEvent(target) {
      let me = this;
      var distX = target.changedTouches[0].clientX - me.clickX;

      if (me.progressLen + distX < 0) {
        me.progressLen = 0;
        me.activeMinute = "00";
        me.activeSeconds = "00";
      } else if (me.progressLen + distX > me.domWidth) {
        me.progressLen = me.domWidth;
        me.activeMinute = me.musicMinute;
        me.activeSeconds = me.musicSeconds;
      } else {
        me.progressLen += distX;
        var point = me.progressLen / me.domWidth;
        me.activeMinute =
          Number((me.ALLTIME * point) / 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) / 60))
            : parseInt(Number((me.ALLTIME * point) / 60));
        me.activeSeconds =
          Number((me.ALLTIME * point) % 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) % 60))
            : parseInt(Number((me.ALLTIME * point) % 60));
        me.progressLen += distX;
      }

      me.clickX = target.changedTouches[0].clientX;
    },

    playPreview(mp3Url) {
      //试听功能
      // 获取音频播放器容器
      let oldVoice = this.myVid.volume;

      if (this.myVid) {
        this.myVid.volume = this.calculateOutput();
      }

      const container = document.getElementById("audio-player-container");
      if (this.currentAudio && encodeURI(mp3Url) == this.currentAudio.src) {
        this.currentAudio.pause();
        this.currentAudio.src = "";
        this.currentAudio = null;
        container.innerHTML = "";
        this.myVid.volume = this.myVidVolume;
        return;
      }
      // 清空容器中的内容
      container.innerHTML = "";

      // 创建音频元素
      const audio = document.createElement("audio");
      audio.controls = true;
      audio.src = mp3Url;
      let me = this;
      audio.addEventListener("ended", function() {
        me.myVid.volume = 1;
        container.innerHTML = "";
        me.currentAudio = null;
      });
      // 将音频元素添加到容器中
      container.appendChild(audio);

      // 自动播放音频
      audio.play();
      this.currentAudio = audio;
    },
    progessClick(e) {
      let me = this;
      e.stopPropagation();
      var domToLeft = this.$refs.totProgress.getBoundingClientRect().left;
      var clientX = e.clientX;
      var result = me.progressLen;
      var distX = clientX - domToLeft - result;

      me.playStatus = 1;
      if (result + distX < 0) {
        me.progressLen = 0;
        me.activeMinute = "00";
        me.activeSeconds = "00";
      } else if (result + distX > me.domWidth) {
        me.progressLen = me.domWidth;
        me.activeMinute = me.musicMinute;
        me.activeSeconds = me.musicSeconds;
      } else {
        me.progressLen += distX;
        var point = me.progressLen / me.domWidth;
        me.activeMinute =
          Number((me.ALLTIME * point) / 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) / 60))
            : parseInt(Number((me.ALLTIME * point) / 60));
        me.activeSeconds =
          Number((me.ALLTIME * point) % 60) < 10
            ? "0" + parseInt(Number((me.ALLTIME * point) % 60))
            : parseInt(Number((me.ALLTIME * point) % 60));

        result += distX;
      }
      me.myVid.currentTime = (me.progressLen / me.domWidth) * me.ALLTIME;
    },

    drawProcess(time) {
      this.percentage = Number(((time / this.ALLTIME) * 100).toFixed(2));
    },
  },
};
</script>
<style lang="less" src="./style.less"></style>
